<template>
  <transition name="wait-to-appear">
    <div
      v-if="show"
      class="moreItems gettingMore"
    >
      <div class="moreItemsSpinnerContainer">
        <Spinner />
      </div>
      <span>{{ label }}</span>
    </div>
  </transition>
</template>

<script>

import Spinner from './Spinner'

export default {
  name: 'GettingMore',
  components: {
    Spinner,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    show: {
      type: [Boolean, Number],
      default: true,
    },
  },
}

</script>
